export async function syncCartAfterLogin(): Promise<void> {
  const { useCartStore } = await import("@/store/cartStore");
  await useCartStore.getState().syncWithApi({ silent: true });
}

